import { css } from "styled-components";
import { normalize } from "styled-normalize";

export const resetStyles = css`
  ${normalize};
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.875rem;
    background-image: none;
    -webkit-text-size-adjust: 100%;
    overflow-y: hidden;
  }

  a {
    text-decoration: none;
  }
`;
